if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
			// Optional
			loadProductFirst: true,
			showPlaceholderProductList: true,
			placeholderProductPerRow: 5,
			placeholderProductGridItemClass: 'grid__item small--one-half medium-up--one-fifth',
          	filterTreeMobileStyle: 'style1'
		}
	};
}

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		 // Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add onSale label
		var itemSaleLabelHtml = onSale ? boostPFSTemplate.saleLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

		// Add soldOut label
		var itemSoldOutHtml = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutHtml);

		// Add Image
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data, 235));

		// Add Thumbnail
		var itemThumbUrl = Utils.getFeaturedImage(images, '480x480');
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			if (priceVaries) {
				itemPriceHtml = (boostPFSThemeConfig.label.sale_from_price).replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
			} else {
				itemPriceHtml = '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
				itemPriceHtml += '<s class="product-card__regular-price">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat)  + '</s> ';
				itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
				itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			if (priceVaries) {
				itemPriceHtml = (boostPFSThemeConfig.label.from_price).replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
			} else {
				itemPriceHtml = '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
				itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		itemHtml = itemHtml.replace(/{{itemViewLabel}}/g, boostPFSThemeConfig.label.view);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	function buildImages(data, img_width) {
		var html = '',
			maximum_width = '',
			width = data.images_info.length > 0 ? data.images_info[0].width : 480,
			height = data.images_info.length > 0 ? data.images_info[0].height : 480,
			ratio = width / height;

		if (data.images != null) {
			if (ratio < 1.0) {
				maximum_width = img_width * ratio;
				if (height <= img_width) {
					maximum_width = width;
				}
			} else {
				if (width <= img_width) {
					maximum_width = width;
				} else {
					maximum_width = img_width;
				}
			}
		} else {
			maximum_width = img_width;
		}

		html += '<div class="product-card__image js" style="max-width: ' + maximum_width + 'px;" data-image-id="' + (data.images_info[0] != null ? data.images_info[0]['id'] : '') + '">';
		html += '<div style="padding-top:' + (1 / ratio * 100) + '%;">';
		html += '<img class="lazyload" ' +
				'src="' + Utils.getFeaturedImage(data.images_info, '300x300') + '" ' +
				'data-src="' + Utils.getFeaturedImage(data.images_info, '{width}x') + '" ' +
				'data-widths="[100, 140, 180, 250, 305, 440, 610, 720, 930, 1080]" ' +
				'data-aspectratio="' + ratio + '" ' +
				'data-sizes="auto" ' +
				'data-parent-fit="contain" ' +
				'alt="{{itemTitle}}">';
		html += '<noscript><img class="product-card__image" src="' + Utils.getFeaturedImage(data.images_info, '480x480') + '" alt="{{itemTitle}}"></noscript>';
		html += '</div>';
		html += '</div>';

		return html;
	}

	// Custom product placeholder
	ProductListPlaceholder.prototype.getTemplate = function() {
		return '<div class="{{wrapperClass}} {{class.filterProductSkeleton}}">' +
					'<a class="product-card">' +
						'<div class="{{class.filterProductSkeleton}}-image" style="padding-top: {{paddingTop}}%"></div>' +
						'<div class="{{class.filterProductSkeleton}}-meta">' +
							'<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>' +
							'<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>' +
						'</div>' +
					'</a>' +
				'</div>';
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage -1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Show Limit block
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k = 0; k < arr.length; k++) {
					showLimitItemsHtml += '<option value="' + arr[k] +'">' + arr[k] + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      	
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	}
    $( document ).ready(function() {
        console.log( "ready!" );
      	myFunction();
    });
})();